import { render, staticRenderFns } from "./AcceptAddressRequest.vue?vue&type=template&id=4bea25db&"
import script from "./AcceptAddressRequest.vue?vue&type=script&lang=js&"
export * from "./AcceptAddressRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports